module.exports = __webpack_public_path__ + "static/logo-1977355307c34480f637488a9a4d89ba.svg";